export default "__VITE_ASSET__hnsvid8R__"